import {
  BooleanInput,
  SimpleForm,
  SimpleFormProps,
  TextInput,
  required
} from 'react-admin';
import { UploadImageInput } from '../../components';

export default function CertificationsForm(props: Partial<SimpleFormProps>) {
  return (
    <SimpleForm {...props} redirect="list">
      <TextInput
        autoComplete="off"
        fullWidth
        label="Título"
        source="title"
        validate={[required()]}
      />

      <UploadImageInput
        fullWidth
        helperText="É possível enviar imagens nos formatos JPEG e PNG"
        label="Imagem"
        mimeTypes={['image/jpeg', 'image/png']}
        source="image"
        validate={[required()]}
      />

      <BooleanInput label="Ativo" source="active" defaultValue />
    </SimpleForm>
  );
}
